@if (spotlight.state(); as state) {
  @if (box(); as b) {
    <div
      class="agent-spotlight__ring"
      [class.agent-spotlight__ring--dim]="state.kind === 'tour'"
      [class.agent-spotlight--overlay]="overlay()"
      [style.top.px]="b.top"
      [style.left.px]="b.left"
      [style.width.px]="b.width"
      [style.height.px]="b.height"
      aria-hidden="true"
    ></div>
  }
  <!-- A highlight without text is just the ring — an empty bubble with only its X looked broken. -->
  @if ((state.kind === 'tour' || step?.title || step?.body) && bubble(); as p) {
    <div
      class="agent-spotlight__bubble al-glass al-glass--popover"
      [class.agent-spotlight--overlay]="overlay()"
      [style.top.px]="p.top"
      [style.left.px]="p.left"
      role="dialog"
      [attr.aria-label]="step?.title || ('agentPanel.spotlight.label' | translate)"
    >
      <div class="al-glass__body">
        <button
          type="button"
          class="agent-spotlight__close"
          (click)="spotlight.close()"
          [attr.aria-label]="'agentPanel.spotlight.close' | translate"
        >
          <nb-icon icon="close-outline"></nb-icon>
        </button>
        @if (step?.title) {
          <p class="agent-spotlight__title">{{ step?.title }}</p>
        }
        @if (step?.body) {
          <p class="agent-spotlight__body">{{ step?.body }}</p>
        }
        @if (step?.tip) {
          <p class="agent-spotlight__tip">
            <nb-icon icon="bulb-outline"></nb-icon>
            <span>{{ step?.tip }}</span>
          </p>
        }
        @if (state.kind === 'tour') {
          <div class="agent-spotlight__actions">
            @if (state.index > 0) {
              <button nbButton size="small" status="basic" type="button" (click)="spotlight.back()">
                {{ 'agentPanel.spotlight.back' | translate }}
              </button>
            }
            @if (state.index + 1 >= state.steps.length && state.finish; as finish) {
              <button nbButton size="small" status="primary" type="button" (click)="spotlight.finishTour()">
                {{ finish.label }}
              </button>
            } @else {
              <button nbButton size="small" status="primary" type="button" (click)="spotlight.next()">
                {{ (state.index + 1 >= state.steps.length ? 'agentPanel.spotlight.done' : 'agentPanel.spotlight.next') | translate }}
              </button>
            }
          </div>
        }
      </div>
    </div>
  }
}
